/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Generate/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DocumentTemplate from './DocumentTemplate/index'
import GenerateAction from './GenerateAction/index'
import React from 'react'
import Recipients from './Recipients/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Generate({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Generate"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Generate.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-2dpF7B': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Letter"
/>
<div
  data-testid="Generate.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<DocumentTemplate
  viewPath={`${viewPath}/DocumentTemplate`}
/>
<Recipients
  viewPath={`${viewPath}/Recipients`}
/>
<GenerateAction
  viewPath={`${viewPath}/GenerateAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}